import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {EMPTY} from 'rxjs';
import {map, mergeMap, catchError, exhaustMap} from 'rxjs/operators';
import { ScanBoletoService } from 'src/app/services/convenio/scan-boleto.service';
import {Boleto} from'../../models/pouch.db';
import { ActionsBoleto } from '../actions/scanBoleto.actions';
import { BoletoState } from 'src/app/core/models/boleto.state';

@Injectable()
export class BoletoEffects {

  boleto: Boleto;

  postBoleto$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionsBoleto.POST_BOLETO),
      exhaustMap((action : BoletoState) => this.scanBoletoService.saveBoletoLocal(action.boleto)
        .pipe(
          map(boleto => ({type: ActionsBoleto.POSTED_BOLETO, boleto})),
          catchError(() => EMPTY)
        ))
    );
  });

  constructor(
    private actions$: Actions,
    private scanBoletoService: ScanBoletoService
  ) {
  }
}
